import { Component, ChangeDetectionStrategy } from '@angular/core';

import { GridPanelComponent } from '../grid-panel/grid-panel.component';

@Component({
    selector: 'aa-grid-double-panel',
    templateUrl: '../grid-simple-panel/grid-simple-panel.component.html',
    styleUrls: [
        '../grid-container.constants.scss',
        './grid-double-panel.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GridDoublePanelComponent extends GridPanelComponent
{
}
